import React, { useState } from 'react';
import { Table, Form, Input, Select, Statistic, Button } from 'antd';
import { DislikeOutlined, LikeOutlined } from '@ant-design/icons';
const { Option } = Select;
var _ = require('lodash');

const columns = [
    {
        title: 'Parameter',
        dataIndex: 'parameter',
        width: 250,
    },
    {
        title: 'Execution Parameter',
        dataIndex: 'sub_parameter',
        render: text => {
            return <p>{text.split("<BR>").map(item => <div>{item}<br /></div>)}</p>
        },
    },
    {
        title: "Feedback",
        dataIndex: "feedback",
        width: 350,
        render: (_, record) => {
            if (record.disabled) {
                return <p>{record.selected_option}</p>
            }
            return <Form.Item
                name={record.key}
                rules={[{ required: true, message: "Please select" }]}
            >
                <Select defaultValue={record.score} disabled={record.disabled} onSelect={(score) => record.updateFunction(record.key, score)}>
                    {record.input_options.map(item => <Option value={item.score}>{item.option}</Option>)}
                </Select>
            </Form.Item>
        },
    },
    {
        title: 'Score',
        dataIndex: 'score',
        width: 200,
        align: "center",
        key: 'score',
    },
];
const parameters = [
    {
        key: 'manpower_mobilisation',
        parameter: 'Manpower augmentation',
        category: 'Time Schedule',
        sub_parameter: 'Mobilisation of the required manpower as per monthly commitment',
        score: 0,
        weight: 20,
        weighted_score: 0,
        input_options: [{ option: '>90% compliance', score: 4 }, { option: '81% -90%', score: 3 }, { option: '71% - 80%', score: 2 }, { option: '60% - 70%', score: 1 }, { option: '<60%', score: 0 }],
    },
    {
        key: 'other_mobilisation',
        parameter: 'Mobilisation of other resources',
        category: 'Time Schedule',
        sub_parameter: 'Mobilisation of equipment (age of equipment to be as per AMNS safety guidelines) and other tools/ resources as per monthly commitment',
        input_options: [{ option: '>90% compliance', score: 4 }, { option: '81% - 90%', score: 3 }, { option: '71% - 80%', score: 2 }, { option: '60% - 70%', score: 1 }, { option: '<60%', score: 0 }],
        score: 0,
        weight: 20,
        weighted_score: 0,
    },
    {
        key: 'work_completion',
        parameter: 'Work completion (Quantity)',
        category: 'Time Schedule',
        sub_parameter: '% Completion of Monthly planned qty.',
        input_options: [{ option: '>90% compliance', score: 4 }, { option: '81% - 90%', score: 3 }, { option: '71% - 80%', score: 2 }, { option: '60% - 70%', score: 1 }, { option: '<60%', score: 0 }],
        score: 0,
        weight: 45,
        weighted_score: 0,
    },
    {
        key: 'lookahead_plan',
        parameter: 'Look ahead plan',
        category: 'Time Schedule',
        score: 0,
        weight: 15,
        weighted_score: 0,
        sub_parameter: '1) 3 months look ahead plan submitted for quantity.<BR>2) 3 Months Milestone plan submitted.<BR>3) Weekly manpower and other resources deployment plan submitted for next month along with tentative Manpower deployment plan for subsequent 2 months.<BR>4) Updated Schedule/ S-curve submitted on monthly basis.',
        input_options: [{ option: 'All 4 requirements fulfilled', score: 4 }, { option: '3 requirements fulfilled', score: 3 }, { option: '2 requirements fulfilled', score: 2 }, { option: '1 requirement fulfilled', score: 1 }, { option: 'No requirement fulfilled', score: 0 }],
    },

];

const ScheduleFeedback = ({ updateScore, disabled, initialValues }) => {

    const updateData = (key, score) => {
        let count = 0
        let updateData = data.map(item => {
            if (item.key == key) {
                item.score = score
                item.weighted_score = (score * item.weight) / 100
            }
            count = count + item.weighted_score
            return item;
        })
        setWeightedScore(count)
        setData(updateData)
        updateScore("Time Schedule", updateData)
    }

    const [weightedScore, setWeightedScore] = useState(0)

    const [data, setData] = useState(() => {
        let count = 0;
        let updatedParameters = parameters.map(item => {
            item.updateFunction = updateData
            item.disabled = disabled
            if (initialValues) {
                let option = initialValues.scores.filter(x => x.key == item.key)
                if (option.length > 0) {
                    item.selected_option = option[0].selected_option
                    item.score = option[0].score
                    item.weighted_score = option[0].weighted_score
                    count += option[0].weighted_score
                } else {
                    item.selected_option = ""
                }
            }
            return item;
        })
        setWeightedScore(count)
        return updatedParameters;
    });

    return (
        <>
            {!disabled && <>
                <div style={{ padding: "10px", float: "right", marginRight: "15px", background: "white", border: "1px solid lightgray", borderRadius: "10px" }}>
                    <Statistic
                        title="Overall Time Schedule"
                        valueStyle={{ color: weightedScore <=2 ? '#b22222' : weightedScore <=3 ? '#ff6347': weightedScore <=3.5 ? '#ffd700': '#32cd32' }}
                        prefix={weightedScore < 3 ? <DislikeOutlined /> : <LikeOutlined />}
                        value={weightedScore}
                        precision={2} />
                </div>
                <br /><br /><br /><br /></>}
            <div className='form-box' >
                {(initialValues.scores.some(obj => obj.category === 'Time Schedule')) ?
                    <div className='score-legend' 
                    style={{ background: weightedScore <=2 ? '#b22222' : weightedScore <=3 ? '#ff6347': weightedScore <=3.5 ? '#ffd700': '#32cd32' }}>
                        <p style={{ margin: "0px" }}>Overall Time Schedule Score - {weightedScore.toFixed(2)}</p>
                    </div> :
                    <div className='score-legend' style={{ background: '#838383' }}>
                        <p style={{ margin: "0px" }}>Time Schedule Feedback Pending</p>
                    </div>}
                <Table
                    bordered={true}
                    columns={columns}
                    pagination={false}
                    size="small"
                    dataSource={_.cloneDeep(data)} />


            </div>

        </>
    );
}
export default ScheduleFeedback;